module.exports = __webpack_public_path__ + "static/media/15.ac0252c9.wav";